import { createContext, ReactNode, useContext, useState } from 'react';

interface IncentivesContextType {
  clusterChangeCount: number;
  setClusterChangeCount: React.Dispatch<React.SetStateAction<number>>;
  clustersVersion: number;
  setClustersVersion: React.Dispatch<React.SetStateAction<number>>;
  resetTracking: () => void;
}

interface IncentivesContextProviderProps {
  children: ReactNode;
}

const IncentivesContext = createContext<IncentivesContextType | null>(null);

export const IncentivesContextProvider = ({
  children,
}: IncentivesContextProviderProps) => {
  const [clusterChangeCount, setClusterChangeCount] = useState(0);
  const [clustersVersion, setClustersVersion] = useState(0);

  const resetTracking = () => {
    setClusterChangeCount(0);
    setClustersVersion(0);
  };

  return (
    <IncentivesContext.Provider
      value={{
        clusterChangeCount,
        setClusterChangeCount,
        clustersVersion,
        setClustersVersion,
        resetTracking,
      }}
    >
      {children}
    </IncentivesContext.Provider>
  );
};

export const useIncentivesContext = (): IncentivesContextType => {
  const context = useContext(IncentivesContext);
  if (!context) {
    throw new Error(
      'useIncentivesContext must be used within IncentivesContextProvider'
    );
  }

  return context;
};
